import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation, OnDestroy, AfterContentChecked } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { NewContractModalResumeComponent } from './components/new-contract-modal-resume/new-contract-modal-resume.component';
import {
  DropdownsValues,
  HiringData,
  NewContractLargeAccounts,
  NewOffer,
  SelectedCampaign,
  SelectedOffer,
  SelectedTradingAccount,
  SelectedType
} from './new-contract-large-accounts.model';
import { NewContractLargeAccountsService } from './new-contract-large-accounts.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-new-contract-large-accounts',
  templateUrl: './new-contract-large-accounts.component.html',
  styleUrls: ['./new-contract-large-accounts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewContractLargeAccountsComponent implements OnInit, OnDestroy, AfterContentChecked {
  public isLoading: boolean;
  public progress = 0;
  public tabIndex = 0;
  public goNext = false;
  public dataForms: NewContractLargeAccounts = {};
  public dataOffer: NewOffer = {};
  public dropdownsValues: DropdownsValues = {};
  public idContract: string;
  public fromOffer: boolean;
  public codTradingAccount: string;
  private destroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private location: Location,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private utilService: UtilService,
    private newContractLargeAccountsService: NewContractLargeAccountsService,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activeRoute.queryParams.pipe(takeUntil(this.destroyed$)).subscribe((res: Params) => {
      if (res.codTradingAccount) {
        this.codTradingAccount = res.codTradingAccount;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  public handleGoBack(): void {
    this.location.back();
  }

  public tabChange(event): void {
    if (this.tabIndex !== event.index + 1) {
      this.tabIndex = event.index + 1;
    }
  }

  public handleOpenProgress(): void {
    if (this.tabIndex > 1) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        autoFocus: false,
        disableClose: true,
        height: window.screen.height,
        width: '472px',
        position: {
          right: '0px'
        },
        data: {
          step: this.tabIndex,
          dataForm: this.dataForms,
          dropdownsValues: this.dropdownsValues,
          fromOffer: this.fromOffer,
          dataOffer: this.dataOffer
        }
      };
      this.dialog.open(NewContractModalResumeComponent, dialogConfig.data);
    }
  }

  public handleChangeLoader(event: boolean): void {
    this.isLoading = event;
  }

  public handleGoNext(): void {
    switch (this.tabIndex) {
      case 0:
        this.goNext = false;
        this.tabIndex = 1;
        this.progress = this.fromOffer ? 33 : 25;
        break;
      case 1:
        this.goNext = false;
        this.tabIndex = 2;
        this.progress = this.fromOffer ? 66 : 50;
        break;
      case 2:
        if (this.fromOffer) {
          this.setContract(3);
        } else {
          this.newOffer();
        }
        break;
      case 3:
        this.setContract(4);
        break;
    }
  }

  public handleCanGoNextTab0(event: SelectedType): void {
    this.goNext = event.valid;
    this.fromOffer = event.value === '0';
  }

  public handleCanGoNextTab1Offer(event: SelectedOffer): void {
    this.goNext = event.valid;
    this.dataForms.codigoOferta = event.offer;
    this.dropdownsValues.offer = event.offerLabel;
    this.dataForms.valorOMIP = parseFloat(event.omip);
  }

  public handleCanGoNextTab1Campaign(event: SelectedTradingAccount): void {
    this.goNext = event.valid;
    this.dataOffer.codCuentaNegociadora = event.traddingAccount;
    this.dropdownsValues.traddingAccount = event.traddingAccountLabel;
    this.dataOffer.codesRazonSocial = event.socialReason;
    this.dataOffer.todasRazonesSociales = event.allSocialReason;
    this.dropdownsValues.socialReason = event.socialReasonLabels?.join();
    this.dataOffer.codesInstalacion = event.installation;
    this.dataOffer.todasInstalaciones = event.allInstallation;
    this.dropdownsValues.installation = event.installationLabels?.join();
  }

  public handleCanGoNextHiring(event: HiringData): void {
    this.goNext = event.valid;
    this.dataForms.fechaInicio = this.utilService.formatDate(event.startContract);
    this.dataForms.fechaFin = this.utilService.formatDate(event.endContract);
    this.dataForms.nombreTipoViaDireccion = event.viaType;
    this.dataForms.nombreDireccion = event.roadName;
    this.dataForms.numeroDireccion = event.number;
    this.dataForms.portalDireccion = event.gate;
    this.dataForms.escaleraDireccion = event.stair;
    this.dataForms.pisoDireccion = event.floor;
    this.dataForms.puertaDireccion = event.door;
    this.dataForms.codPostalDireccion = event.postalCode;
    this.dataForms.codigoPoblacionDireccion = event.town;
    this.dropdownsValues.townLabel = event.townLabel;
    this.dataForms.iban = event.iban;
    this.dataForms.entidad = event.entity;
    this.dataForms.sucursal = event.office;
    this.dataForms.dc = event.dc;
    this.dataForms.cuenta = event.account;
    this.dataForms.listaFirmantes = [
      {
        nombreFirmante: event.name,
        apellidosFirmante: event.surname,
        dniFirmante: event.dni,
        movilFirmante: event.phone,
        mailFirmante: event.email
      }
    ];
    if (event.name2) {
      this.dataForms.listaFirmantes.push({
        nombreFirmante: event.name2,
        apellidosFirmante: event.surname2,
        dniFirmante: event.dni2,
        movilFirmante: event.phone2,
        mailFirmante: event.email2
      });
    }
  }

  public handleCanGoNextTab2Campaign(event: SelectedCampaign): void {
    this.goNext = event.valid;
    this.dataOffer.codigoCampania = event.campaign;
    this.dropdownsValues.campaign = event.campaingLabel;
    this.dataOffer.nombreNivel = event.level;
    this.dataOffer.renovacionTacita = event.renovate;
    this.dataOffer.impuestoElectrico = event.electric;
    this.dataForms.valorOMIP = parseFloat(event.omip);
  }

  private getDate(): string {
    const today = new Date();
    const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
    const month = (today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1;
    const year = today.getFullYear();
    const hour = today.getHours() < 10 ? '0' + today.getHours() : today.getHours();
    const minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();
    const second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds();
    return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
  }

  private newOffer(): void {
    this.isLoading = true;
    this.dataOffer.nombreOferta = `Oferta desde contrato (${this.getDate()})`;
    this.newContractLargeAccountsService.setOffer(this.dataOffer).pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        if (response.success) {
          this.goNext = false;
          this.dataForms.codigoOferta = response.data[0];
          this.tabIndex = 3;
          this.progress = 75;
        } else {
          this.utilService.toastErrors(response);
        }
        this.isLoading = false;
      },
      error => {
        this.isLoading = false;
        this.utilService.toastErrors(error);
      });
  }

  private setContract(nextTab: number): void {
    this.isLoading = true;
    this.newContractLargeAccountsService.setContract(this.dataForms).pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        if (response.success) {
          this.idContract = response.data;
          this.tabIndex = nextTab;
          this.progress = 100;
        } else {
          this.utilService.toastErrors(response);
        }
        this.isLoading = false;
      },
      error => {
        this.isLoading = false;
        this.utilService.toastErrors(error);
      });
  }
}
